import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useUnmount from 'common/hooks/useUnmount';
import { Row, Col } from 'antd';

import { RegistrationForm } from 'common/forms';
import { RegistrationFormValues } from 'common/models/User';
import { I18nNameSpaces } from 'common/services/i18n';

import { AuthPageDescription } from '../../components';
import { registrationResetAction, selectRegistrationSuccess } from './ducks';

function RegistrationFeature() {
  const { t } = useTranslation(I18nNameSpaces.Auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const success = useSelector(selectRegistrationSuccess);

  const [registration, setRegistration] = useState<{
    authStep: RegistrationFormValues | null;
    profileStep: null;
  }>({ authStep: null, profileStep: null });

  useEffect(() => {
    if (success && location.pathname === '/auth/registration') {
      navigate('/auth/login');
    }
  }, [success, navigate, location]);

  useUnmount(() => {
    dispatch(registrationResetAction());
  });

  function handleRegisterSubmit(values: RegistrationFormValues) {
    setRegistration({ ...registration, authStep: values });
  }

  return (
    <Row justify="center">
      <Col xs={24} md={8}>
        <AuthPageDescription title={t('registration.page.title')} description={t('registration.page.description')} />
        <RegistrationForm onSubmit={handleRegisterSubmit} />
      </Col>
    </Row>
  );
}

export default RegistrationFeature;
